import { PayloadAction, createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'src/store/store';
import guidesApiService from 'src/api/services/guidesApiService';
import { CititesState } from './types';
import { notification } from 'antd';

const initialState: CititesState = {
    isLoading: false,
    items: [],
    filter: {}
};

export const loadCitiesAsync = createAsyncThunk('cities/load', async () => {
    try {
        const data = await guidesApiService.getCities();
        return data;
    } catch (error) {
        if (error instanceof Error) {
            notification.error({ message: error.message });
            throw error;
        }
        throw new Error();
    }
});

const slice = createSlice({
    name: 'cities',
    initialState,
    reducers: {
        reset: () => initialState,
        nameFilterChanged: (state, action: PayloadAction<string>) => {
            state.filter.name = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadCitiesAsync.pending, (state) => {
                state.isLoading = true;
                state.items = [];
            })
            .addCase(loadCitiesAsync.fulfilled, (state, action) => {
                state.isLoading = false;
                state.items = action.payload;
            })
            .addCase(loadCitiesAsync.rejected, (state) => {
                state.isLoading = false;
            });
    }
});

export const { reset, nameFilterChanged } = slice.actions;

const selectCities = (state: AppState) => state.cities;

const selectItems = (state: AppState) => selectCities(state).items;

export const selectFilter = (state: AppState) => selectCities(state).filter;

export const selectFilteredItems = createSelector([selectItems, selectFilter], (items, filter) => {
    let result = items;
    if (filter.name) {
        result = result.filter((item) => item.name.toLowerCase().includes(filter.name!.toLowerCase()));
    }
    return result;
});

export const selectTotalCount = createSelector(selectFilteredItems, (items) => items.length);

export const selectIsLoading = (state: AppState) => selectCities(state).isLoading;

export default slice.reducer;
